import MoreInsightButton from "./MoreInsightButton";

export default function Wrapper(props: any) {
  const {
    children,
    customClass,
    insightCustomCSS = "",
    insights = true,
    moreInsights = {},
    onClick=()=>{}
  } = props;
  return (
    <div
      className={`w-full p-4 bg-white rounded-lg shadow-dark relative ${customClass}`}
      style={{ boxShadow: "0px 2px 2px 0px #00000040" }}
      onClick={onClick}
    >
      {children}
      <div className="w-full mb-4">
      </div>
      {insights && (
        <MoreInsightButton
          moreInsights={moreInsights}
          customClass={`mt-3 ${insightCustomCSS}`}
        />
      )}
    </div>
  );
}
